import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file",
  "use": "file-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 .5v15a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5v-12a.5.5 0 01.146-.354l3-3A.5.5 0 015.5 0h9a.5.5 0 01.5.5zM14 1H5.707L3 3.707V15h11V1z\" /><path d=\"M4 5.5a.5.5 0 01.5-.5H7V2.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol